import { RANK_TIME_LABEL, fmtWeekdayDate } from '@remote-medium/shared';
import { ErrorState, LoadingState, useApi } from '@remote-medium/ui';

import { useBillingEnabled } from '../../lib/billing.tsx';
import { loadOverview } from './components/context.ts';
import { CandidatePoolCard, RolesCard } from './components/CountCards.tsx';
import { LatestJobs } from './components/LatestJobs.tsx';
import { buildTasks } from './components/tasks.ts';
import { WaitingOnYou } from './components/WaitingOnYou.tsx';

function Header({ now }: { now: Date }) {
  return (
    <header className="flex flex-col gap-1">
      <h1 className="m-0 font-serif text-2xl font-medium tracking-tight">Overview</h1>
      <p className="m-0 text-sm text-muted-foreground">
        {fmtWeekdayDate(now.toISOString())} · Ranked by clear rules at {RANK_TIME_LABEL}, confirmed
        by you.
      </p>
    </header>
  );
}

export function OverviewPage() {
  const billing = useBillingEnabled();
  const { data, error, loading } = useApi(loadOverview, []);
  if (loading) return <LoadingState />;
  if (error || !data) return <ErrorState error={error} />;

  // Dates are relative to the server's clock, not the browser's.
  const now = new Date(data.now);
  const { tasks, clear } = buildTasks(data, now, billing);

  return (
    <div className="flex flex-col gap-10">
      <Header now={now} />
      <div className="grid grid-cols-1 items-start gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,24rem)]">
        <WaitingOnYou tasks={tasks} clear={clear} />
        <div className="flex flex-col gap-6">
          <CandidatePoolCard byStatus={data.candidatesByStatus} />
          <RolesCard byStatus={data.rolesByStatus} />
        </div>
      </div>
      <LatestJobs jobs={data.jobs} emails={data.emailsLast24h} />
    </div>
  );
}
